export const checkAddressEquality = (data: any) => {
  if (!data) return false;
  const deliveryFields = Object.entries(data).filter(([key]) => key.endsWith('deliver'));

  if (!deliveryFields.length) return true;

  return deliveryFields.every(([key, value]) => {
    const addressKey = key.replace('_deliver', '');
    return data[addressKey] === value;
  });
};
